import {
  SSHInstance,
  SSHInstanceStatus,
  ListSSHInstancesResponse,
  TerminateSSHResponse,
  TaskActionResponse,
} from '@/service/gpu-instance/type';

// Demo workspace ID for mock data
export const DEMO_WORKSPACE_ID = 'demo-workspace';

// Mock SSH Instances
export const mockSSHInstances: SSHInstance[] = [
  // Base VM instances (no tag)
  {
    task_id: 'demo-instance-001',
    task_name: 'Demo ML Training Instance',
    status: SSHInstanceStatus.SSHReady,
    start_time: Date.now() - 3600000,
    end_time: null,
    project_id: 'demo-project-001',
    project_name: 'demo-ml-training',
    gpu_type: 'NVIDIA A100 80GB',
    instance_ip: '192.168.100.10',
    created_at: Date.now() - 7200000,
    deleted_at: null,
  },
  {
    task_id: 'demo-instance-002',
    task_name: 'Demo Inference Server',
    status: SSHInstanceStatus.Running,
    start_time: Date.now() - 1800000,
    end_time: null,
    project_id: 'demo-project-002',
    project_name: 'demo-inference',
    gpu_type: 'NVIDIA L4',
    instance_ip: '192.168.100.11',
    created_at: Date.now() - 3600000,
    deleted_at: null,
  },
  {
    task_id: 'demo-instance-003',
    task_name: 'Demo Development',
    status: SSHInstanceStatus.Pending,
    start_time: null,
    end_time: null,
    project_id: 'demo-project-003',
    project_name: 'demo-dev',
    gpu_type: 'NVIDIA T4',
    instance_ip: null,
    created_at: Date.now() - 300000,
    deleted_at: null,
  },
  {
    task_id: 'demo-instance-004',
    task_name: 'Demo Completed Job',
    status: SSHInstanceStatus.Completed,
    start_time: Date.now() - 86400000,
    end_time: Date.now() - 82800000,
    project_id: 'demo-project-004',
    project_name: 'demo-batch-job',
    gpu_type: 'NVIDIA A100 40GB',
    instance_ip: null,
    created_at: Date.now() - 86400000,
    deleted_at: Date.now() - 82800000,
  },
  {
    task_id: 'demo-instance-005',
    task_name: 'Demo Stopped Instance',
    parent_task_id: 'parent-abc12345-original',
    status: SSHInstanceStatus.Stopped,
    start_time: Date.now() - 172800000,
    end_time: null,
    project_id: 'demo-project-005',
    project_name: 'demo-stopped-vm',
    gpu_type: 'NVIDIA L4',
    instance_ip: null,
    created_at: Date.now() - 259200000,
    deleted_at: null,
  },
  // Resumed instance - new task_id but same parent_task_id as demo-instance-005
  {
    task_id: 'demo-instance-005-resumed',
    task_name: 'Demo Stopped Instance (Resumed)',
    parent_task_id: 'parent-abc12345-original',
    status: SSHInstanceStatus.Running,
    start_time: Date.now() - 1800000,
    end_time: null,
    project_id: 'demo-project-005',
    project_name: 'demo-stopped-vm-resumed',
    gpu_type: 'NVIDIA L4',
    instance_ip: '192.168.100.15',
    created_at: Date.now() - 3600000,
    deleted_at: null,
  },
  // Tagged instances - one for each tag type
  {
    task_id: 'demo-vllm-001',
    task_name: 'vLLM Inference Server',
    status: SSHInstanceStatus.SSHReady,
    start_time: Date.now() - 3600000,
    end_time: null,
    project_id: 'demo-vllm-project',
    project_name: 'vllm-llama-70b',
    gpu_type: 'NVIDIA A100 80GB',
    instance_ip: '192.168.100.50',
    created_at: Date.now() - 7200000,
    deleted_at: null,
    instance_tag: 'vllm',
  },
  {
    task_id: 'demo-triton-001',
    task_name: 'Triton Model Server',
    status: SSHInstanceStatus.Running,
    start_time: Date.now() - 5400000,
    end_time: null,
    project_id: 'demo-triton-project',
    project_name: 'triton-embeddings',
    gpu_type: 'NVIDIA L4',
    instance_ip: '192.168.100.51',
    created_at: Date.now() - 7200000,
    deleted_at: null,
    instance_tag: 'triton',
  },
  {
    task_id: 'demo-tao-001',
    task_name: 'TAO Object Detection',
    status: SSHInstanceStatus.Running,
    start_time: Date.now() - 14400000,
    end_time: null,
    project_id: 'demo-tao-project',
    project_name: 'tao-yolov8-training',
    gpu_type: 'NVIDIA A100 40GB',
    instance_ip: '192.168.100.52',
    created_at: Date.now() - 18000000,
    deleted_at: null,
    instance_tag: 'tao',
  },
  {
    task_id: 'demo-monai-001',
    task_name: 'MONAI Medical Imaging',
    status: SSHInstanceStatus.SSHReady,
    start_time: Date.now() - 7200000,
    end_time: null,
    project_id: 'demo-monai-project',
    project_name: 'monai-ct-segmentation',
    gpu_type: 'NVIDIA A100 80GB',
    instance_ip: '192.168.100.53',
    created_at: Date.now() - 10800000,
    deleted_at: null,
    instance_tag: 'monai',
  },
  {
    task_id: 'demo-nemo-001',
    task_name: 'NeMo Speech Training',
    status: SSHInstanceStatus.Running,
    start_time: Date.now() - 10800000,
    end_time: null,
    project_id: 'demo-nemo-project',
    project_name: 'nemo-asr-conformer',
    gpu_type: 'NVIDIA A100 80GB',
    instance_ip: '192.168.100.54',
    created_at: Date.now() - 14400000,
    deleted_at: null,
    instance_tag: 'nemo',
  },
  {
    task_id: 'demo-float16-001',
    task_name: 'Float16 LLM Fine-tuning',
    status: SSHInstanceStatus.Running,
    start_time: Date.now() - 21600000,
    end_time: null,
    project_id: 'demo-float16-project',
    project_name: 'float16-llama-finetune',
    gpu_type: 'NVIDIA H200 141GB',
    instance_ip: '192.168.100.55',
    created_at: Date.now() - 25200000,
    deleted_at: null,
    instance_tag: 'float16-training',
  },
  {
    task_id: 'demo-ocr-001',
    task_name: 'Thai Document OCR',
    parent_task_id: 'parent-ocr-9876abcd',
    status: SSHInstanceStatus.Running,
    start_time: Date.now() - 1800000,
    end_time: null,
    project_id: 'demo-ocr-project',
    project_name: 'thai-document-ocr',
    gpu_type: 'NVIDIA L4',
    instance_ip: '192.168.100.56',
    created_at: Date.now() - 3600000,
    deleted_at: null,
    instance_tag: 'ocr',
  },
  // H200 GPU #1: vLLM cluster (same tag for all MIG slices)
  {
    task_id: 'demo-h200-gpu01-mig-3g',
    task_name: 'vLLM Llama 70B',
    status: SSHInstanceStatus.SSHReady,
    start_time: Date.now() - 7200000,
    end_time: null,
    project_id: 'demo-h200-gpu-01',
    project_name: 'h200-vllm-cluster',
    gpu_type: 'NVIDIA H200 141GB (MIG 3g.71gb)',
    instance_ip: '192.168.100.20',
    created_at: Date.now() - 3600000,
    deleted_at: null,
    instance_tag: 'vllm',
  },
  {
    task_id: 'demo-h200-gpu01-mig-4g',
    task_name: 'vLLM Llama 70B Replica',
    status: SSHInstanceStatus.Running,
    start_time: Date.now() - 5400000,
    end_time: null,
    project_id: 'demo-h200-gpu-01',
    project_name: 'h200-vllm-cluster',
    gpu_type: 'NVIDIA H200 141GB (MIG 4g.71gb)',
    instance_ip: '192.168.100.21',
    created_at: Date.now() - 3600000,
    deleted_at: null,
    instance_tag: 'vllm',
  },
  // H200 GPU #2: Triton cluster (same tag for all MIG slices)
  {
    task_id: 'demo-h200-gpu02-mig-3g',
    task_name: 'Triton Main API',
    status: SSHInstanceStatus.SSHReady,
    start_time: Date.now() - 3600000,
    end_time: null,
    project_id: 'demo-h200-gpu-02',
    project_name: 'h200-triton-cluster',
    gpu_type: 'NVIDIA H200 141GB (MIG 3g.71gb)',
    instance_ip: '192.168.100.30',
    created_at: Date.now() - 7200000,
    deleted_at: null,
    instance_tag: 'triton',
  },
  {
    task_id: 'demo-h200-gpu02-mig-1g-a',
    task_name: 'Triton Embedding A',
    status: SSHInstanceStatus.Running,
    start_time: Date.now() - 1800000,
    end_time: null,
    project_id: 'demo-h200-gpu-02',
    project_name: 'h200-triton-cluster',
    gpu_type: 'NVIDIA H200 141GB (MIG 1g.35gb)',
    instance_ip: '192.168.100.31',
    created_at: Date.now() - 7200000,
    deleted_at: null,
    instance_tag: 'triton',
  },
  {
    task_id: 'demo-h200-gpu02-mig-1g-b',
    task_name: 'Triton Embedding B',
    status: SSHInstanceStatus.Running,
    start_time: Date.now() - 1800000,
    end_time: null,
    project_id: 'demo-h200-gpu-02',
    project_name: 'h200-triton-cluster',
    gpu_type: 'NVIDIA H200 141GB (MIG 1g.35gb)',
    instance_ip: '192.168.100.32',
    created_at: Date.now() - 7200000,
    deleted_at: null,
    instance_tag: 'triton',
  },
  {
    task_id: 'demo-h200-gpu02-mig-1g-c',
    task_name: 'Triton Classifier',
    status: SSHInstanceStatus.SSHReady,
    start_time: Date.now() - 900000,
    end_time: null,
    project_id: 'demo-h200-gpu-02',
    project_name: 'h200-triton-cluster',
    gpu_type: 'NVIDIA H200 141GB (MIG 1g.35gb)',
    instance_ip: '192.168.100.33',
    created_at: Date.now() - 7200000,
    deleted_at: null,
    instance_tag: 'triton',
  },
  {
    task_id: 'demo-h200-gpu02-mig-1g-d',
    task_name: 'Triton Sentiment',
    status: SSHInstanceStatus.Pending,
    start_time: null,
    end_time: null,
    project_id: 'demo-h200-gpu-02',
    project_name: 'h200-triton-cluster',
    gpu_type: 'NVIDIA H200 141GB (MIG 1g.35gb)',
    instance_ip: null,
    created_at: Date.now() - 300000,
    deleted_at: null,
    instance_tag: 'triton',
  },
];

export const mockListSSHInstancesResponse: ListSSHInstancesResponse = {
  status: 'success',
  instances: mockSSHInstances,
  total: mockSSHInstances.length,
};

export const mockTerminateSSHResponse = (taskId: string): TerminateSSHResponse => ({
  status: 'success',
  task_id: taskId,
  details: 'Instance terminated successfully (Demo)',
});

export const mockStopSSHResponse = (taskId: string): TaskActionResponse => ({
  status: 'success',
  task_id: taskId,
  details: `SSH instance ${taskId} stopped successfully (Demo)`,
});

export const mockResumeSSHResponse = (taskId: string): TaskActionResponse => ({
  status: 'success',
  task_id: taskId,
  details: `SSH instance ${taskId} resumed successfully (Demo)`,
});

// Mock SSH connection info
export const mockSSHConnectionInfo = {
  host: 'demo.float16.cloud',
  port: 22,
  username: 'demo-user',
  privateKey: `-----BEGIN OPENSSH PRIVATE KEY-----
b3BlbnNzaC1rZXktdjEAAAAABG5vbmUAAAAEbm9uZQAAAAAAAAABAAABlwAAAAdzc2gtcn
NhAAAAAwEAAQAAAYEA... (Demo Private Key - Not Real)
-----END OPENSSH PRIVATE KEY-----`,
};

// Get a single mock instance by ID
export const getMockSSHInstanceById = (instanceId: string): SSHInstance | undefined => {
  return mockSSHInstances.find((instance) => instance.task_id === instanceId);
};
